// extracted by mini-css-extract-plugin
export default {"root":"SignInput_root__s++0e","tip":"SignInput_tip__E1GCp","input":"SignInput_input__MDgKd","btn":"SignInput_btn__o8JCC"};